import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {BehaviorSubject, combineLatest} from 'rxjs';

import {LeverageGraphInput} from './lp-leverage-graph/lp-leverage-graph.component';
import {LpLeverageService} from './lp-leverage.service';
import {map, shareReplay} from 'rxjs/operators';

@Component({
  selector: 'terra-lp-leverage',
  templateUrl: './lp-leverage.component.html',
  styleUrls: ['./lp-leverage.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LpLeverageComponent implements OnInit {
  distValue$ = new BehaviorSubject<number>(8);
  appValue$ = new BehaviorSubject<number>(3);

  rawData$ = combineLatest([this.distValue$, this.appValue$]).pipe(
    map(([dist, app]) => {
      return this.service.genData(dist / 100, app / 100, 21);
    }),
    shareReplay(1)
  );
  xirrWithLeverage$ = this.rawData$.pipe(map(rawData => {
    const xirrInput = [];
    rawData.withLeverage.cashflow.forEach((amount, i) => {
      xirrInput.push({amount, when: rawData.dates[i]});
    });

    return this.service.calculateXirr(xirrInput);
  }));
  xirrWithoutLeverage$ = this.rawData$.pipe(map(rawData => {
    const xirrInput = [];
    rawData.withoutLeverage.cashflow.forEach((amount, i) => {
      xirrInput.push({amount, when: rawData.dates[i]});
    });

    return this.service.calculateXirr(xirrInput);
  }));
  totalGainsWithLeverage$ = this.rawData$.pipe(map(rawData => rawData.withLeverage.sumCashflow));
  totalGainsWithoutLeverage$ = this.rawData$.pipe(map(rawData => rawData.withoutLeverage.sumCashflow));
  graphData$ = this.rawData$.pipe(map(rawData => {
    const data = [];
    rawData.withLeverage.gains.forEach((gain, i ) => {
      data.push({ date: rawData.dates[i], withLeverage: gain, withoutLeverage: rawData.withoutLeverage.gains[i] });
    });

    return data;
  }));
  constructor(private service: LpLeverageService) { }

  ngOnInit(): void {
  }

  sliderLabel(value: number) {
    return `${value}%`;
  }

/*  get graphData() {
    return [
      { date: new Date(2022, 1, 1), withoutLeverage: 10_000, withLeverage: 10_200},
      { date: new Date(2022, 2, 1), withoutLeverage: 12_000, withLeverage: 12_300},
      { date: new Date(2022, 3, 1), withoutLeverage: 14_000, withLeverage: 14_400},
      { date: new Date(2022, 4, 1), withoutLeverage: 16_000, withLeverage: 16_600},
    ] as LeverageGraphInput[];
  }*/
}
